import { Form, Row } from 'antd';
import React, { useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import CheckboxComponent from 'components/atoms/CheckboxComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import { IDodatekIsins, dokumentDodatekIsinPut } from 'services/dokumenty/dodatek';

interface IShrnuti {
    isDLT?: boolean;
    isNavyseni: boolean;
    nextStep: () => void;
    prevStep: () => void;
    zadostID: number;
    dodatekData?: IDodatekIsins;
    setSigningDisabled: React.Dispatch<React.SetStateAction<boolean>>;
}

const Shrnuti: React.FC<IShrnuti> = ({
    isDLT,
    isNavyseni,
    nextStep,
    prevStep,
    zadostID,
    dodatekData,
    setSigningDisabled
}) => {
    const [form] = Form.useForm();
    const [isChecked, setIsChecked] = useState<boolean>(dodatekData?.potvrzeno || false);
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        form.setFieldsValue({
            souhlas: dodatekData?.potvrzeno
        });
    }, [dodatekData?.potvrzeno, form]);

    return (
        <LoadingWrapper loading={loading}>
            <FormWrapper outForm={form} onFinish={() => {}}>
                {isDLT ? (
                    <>
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_DLT_1"
                            style={{
                                display: 'block',
                                fontWeight: 'bold'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_DLT_11"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_DLT_12"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text={
                                isNavyseni
                                    ? 'DOKUMENT_DODATEK_SHRNUTI_DLT_13_NAVYSENI'
                                    : 'DOKUMENT_DODATEK_SHRNUTI_DLT_13'
                            }
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_DLT_14"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_DLT_142"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_DLT_115"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Title text="DOKUMENT_DODATEK_SHRNUTI_DLT_2_TITLE" level={5} />
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_DLT_2"
                            style={{
                                display: 'block'
                            }}
                        />
                    </>
                ) : (
                    <>
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_DLT_1"
                            style={{
                                display: 'block',
                                fontWeight: 'bold'
                            }}
                        />
                        <Paragraph
                            text={isNavyseni ? 'DOKUMENT_DODATEK_SHRNUTI_11_NAVYSENI' : 'DOKUMENT_DODATEK_SHRNUTI_11'}
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_12"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_12A"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_12B"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_13"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_13A"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_13B"
                            style={{
                                display: 'block'
                            }}
                        />
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_14"
                            style={{
                                display: 'block',
                                marginTop: 16
                            }}
                        />
                        <Title text="DOKUMENT_DODATEK_SHRNUTI_DLT_2_TITLE" level={5} />
                        <Paragraph
                            text="DOKUMENT_DODATEK_SHRNUTI_DLT_2"
                            style={{
                                display: 'block'
                            }}
                        />
                    </>
                )}

                <Row
                    style={{
                        marginTop: 26
                    }}
                >
                    <CheckboxComponent
                        name="souhlas"
                        checkboxText={<TranslateText>POTVRZENI_CHECKBOX</TranslateText>}
                        onChange={() => setIsChecked(pv => !pv)}
                        checked={isChecked}
                    />
                </Row>
                <Row className="button-row">
                    <ButtonComponent buttontext="ZPET" type="default" onClick={() => prevStep()} id="isinZpetBtn" />
                    <ButtonComponent
                        buttontext="POKRACOVAT"
                        onClick={() => {
                            setLoading(true);
                            dokumentDodatekIsinPut(zadostID!, {
                                ...dodatekData!,
                                potvrzeno: true
                            })
                                .then(() => {
                                    setSigningDisabled(true);
                                    nextStep();
                                })
                                .finally(() => setLoading(false));
                        }}
                        id="isinPokracovatBtn"
                        disabled={!isChecked}
                    />
                </Row>
            </FormWrapper>
        </LoadingWrapper>
    );
};

export default Shrnuti;
